module.exports = __webpack_public_path__ + "files/SOS Critical Skills WS.0a2ea84f.pdf";